import React, { useMemo } from 'react';

// store
import { useStoreValue } from '../../../../../../../../store';
import { armExternalDrag } from '../../../../../../../../store/externalDragStore';

// hooks
import useSelection from '../../../../../../../../hooks/useSelection';
import useCueItemMenu from '../../../../../../../../hooks/useCueItemMenu';
import { SELECTION_KINDS } from '../../../../../../../../helpers/selection';

// tools
import getDateFromISOstring from '../../../../../../../../helpers/getDateFromISOstring';

// components
import BadgeTrack from '../../../../../../../../components/BadgeTrack';
import TripleDotsIcon from '../../../../../../../../icons/TripleDotsIcon';
import ButtonIconSimple from '../../../../../../../../components/ButtonWrapper/components/ButtonIconSimple';
import LikeIcon from '../../../../../../../../icons/LikeIcon';
import ToReviewIcon from '../../../../../../../../icons/ToReviewIcon';
import DislikeIcon from '../../../../../../../../icons/DislikeIcon';
import ButtonIconContextMenu from '../../../../../../../../components/ButtonWrapper/components/ButtonIconContextMenu';

const ListOfSoundtrackItems = () => {
    const cueSheet = useStoreValue('cueSheet');
    const soundtrackItems = useMemo(() => {
        return cueSheet.filter(o => o.cueType === 'MUSIC' && o.clip)
    }, [cueSheet]);

    const orderedIds = useMemo(() => soundtrackItems.map(item => item.id), [soundtrackItems]);
    const { isSelected, select } = useSelection(SELECTION_KINDS.CUE, orderedIds);
    const menuItemsFor = useCueItemMenu();

    return(
        soundtrackItems.map(item => <li key={`music_st_${item.id}`}
            className={`auxListItem${isSelected(item.id) ? ' auxListItem--selected' : ''}`}
            aria-selected={isSelected(item.id)}
            style={{ cursor: 'grab' }}
            onMouseDown={(e) => {
                if (e.button !== 0) return;
                e.preventDefault();
                // The drag only starts once the pointer moves, so a plain press
                // stays a click and selects the item instead.
                armExternalDrag(item, e);
            }}
            onClick={(e) => {
                if (e.target.closest('button, a, input, dialog')) return;
                select(item.id, e);
            }}
        >
            <div>
                <BadgeTrack>{item.label}</BadgeTrack>
            </div>
            <div className="title">
                <h3>{item.title}</h3>
                <span>{item.timecode ?? '-:-'}</span>
            </div>
            <div className="rating lastGroup">
                <ButtonIconSimple>
                    <LikeIcon/>
                </ButtonIconSimple>
                <ButtonIconSimple>
                    <ToReviewIcon/>
                </ButtonIconSimple>
                <ButtonIconSimple>
                    <DislikeIcon/>
                </ButtonIconSimple>
            </div>
            <div className="meta">
                        <span>{getDateFromISOstring(item.date, {
                            day: '2-digit',
                            month: 'short'
                        })}</span>
                <ButtonIconContextMenu menuItems={menuItemsFor(item)}>
                    <TripleDotsIcon/>
                </ButtonIconContextMenu>
            </div>
        </li>)
    )
}

export default ListOfSoundtrackItems;